<template>
  <div class="shopping-guide-page">
    <div class="breadcrumbs">
      <div class="c-layout">
        <span>{{ $t('breadcrumbs.home') }}</span>
        <span class="p-16">/</span>
        <span class="o-color">{{ $t('breadcrumbs.guide') }}</span>
      </div>
    </div>
    
    <p class="s-g-title">{{ $t('breadcrumbs.guide') }}</p>

    <class-picker :list="guideInd" pagename="guide" class="show-on-pad-flex"></class-picker>

    <div class="top-guide c-layout" >
      <router-link
        v-if="topItem"
        :to="{name:'guideDetail',query:{id:topItem.id}}"
        class="content item-block"
      >
      <!-- <div class="content item-block"> -->
        <div class="img-block">
          <img :src="topItem.photo" :alt="topItem.photo" />
        </div>
        <div class="desc detail-block">
          <p class="date">{{moment(topItem.publishdate).format("MMM DD ddd YYYY")}}</p>
          <p class="c-title title">{{topItem.name}}</p>
          <p class="c-tx content">{{topItem.content}}</p>
          <!-- <router-link  class="btn btn-outline-white" target="_blank" :to="{name:'guideDetail',query:{id:topItem.id}}">查看更多</router-link> -->
        </div>
      <!-- </div> -->
      </router-link>
    </div>

    <div class="share-list c-layout" v-if="list" v-loading="loading">
      <router-link
        :to="{name:'guideDetail',query:{id:item.id}}"
        class="share-item item-block"
        v-for="(item,index) in list"
        :key="index"
      >
        <div class="img-block">
          <img :src="item.photo" alt />
        </div>
        <div class="detail-block">
          <p class="date show-on-pad">{{ moment(item.publishdate).format("MMM DD ddd YYYY") }}</p>
          <p class="title">{{item.name}}</p>
          <p class="content">{{item.content}}</p>
          <div class="share-item__bottom hide-on-pad">
            <span>{{moment(item.publishdate).format("YYYY.MM.DD")}}</span>
          </div>
          <!-- <router-link  class="btn btn-outline-white show-on-pad-flex" :to="{name:'guideDetail',query:{id:topItem.id}}">查看更多</router-link>   -->
        </div>
      </router-link>
    </div>
    <!-- <Pagination
      v-if="list"
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @handleCurrentChange="handleCurrentChange"
      @handlePageIndex="handlePageIndex"
    /> -->
    <Pagination
      v-if="list"
      :pageSize="pageSize"
      :pages="currentPage"
      :total="total"
      :listLoading="loading"
      @handelPaginationChange="handleCurrentChange"
    />
  </div>
</template>

<script>
// import Pagination from "@/components/Pagination";
import Pagination from '@/components/Pagination/NewPagination.vue';
import ClassPicker from '@/components/ClassPicker/index.vue';
import { mapState } from 'vuex'
import { getGuideList } from "@/api";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      total:0,
      currentPage: 1,
      pageSize: 10, //每页显示多少条
      list: "",
      topItem: "",
    };
  },
  computed: {
    ...mapState(['guideInd'])
  },
  async mounted() {
    
    this.int = this.$route.query.category || 1;
    this.getList({
      page: this.currentPage,
      count: this.pageSize,
      int: this.int,
    });
  },
  methods: {
    moment,
    handlePageIndex(val) {
      this.currentPage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList({ page: val, count: this.pageSize, int: this.int });
    },
    async getList(data) {
      this.loading = true;
      let res = await getGuideList(data);
      this.list = res.share.data;
      this.total = res.share.total;
      this.topItem = this.list.splice(0, 1)[0];
      this.loading = false;
    },
  },
  components: {
    Pagination,ClassPicker
  },
};
</script>

<style  lang='less'>
.shopping-guide-page {
  .breadcrumbs {
    border-top: 2px solid var(---unnamed-color-b7b7b7);
  }
  a {
    text-decoration: none;
  }

  .top-guide {
    margin-bottom: 29px;
    .content {
      display: flex;
      img {
        width: 540px;
        height: 350px;
        object-fit: cover;
      }
      .desc {
        margin-left: 30px;
        position: relative;
        .date {
          font-size: 16px;
          line-height: 24px;

          color: var(---unnamed-color-707070);
        }
        .c-title {
          margin: 15px 0;

          font-size: 32px;
          line-height: 47px;
          font-weight: 500;
          color: var(---unnamed-color-ec4f00);

          /*! autoprefixer: ignore next */
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 1;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          
        }
        .c-tx {
          /*! autoprefixer: ignore next */
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;

          font-size: 16px;
          line-height: 24px;

          color: var(---unnamed-color-707070);
        }
        .btn {
          position: absolute;
          right: 0;
          bottom: 0;
          cursor: pointer;
          width: 125px;
          height: 40px;

          font-size: 16px;
          color: var(--unnamed-color-111111);
          border: 1px solid var(--unnamed-color-111111);
        }
      }
    }
  }

  .share-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 25px;
    .share-item:nth-child(3n) {
      margin-right: 0px;
    }
    .share-item {
      cursor: pointer;
      width: 350px;
      margin-bottom: 32px;
      display: flex;
      flex-direction: column;
      margin-right: 30px;
      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }
      .title {
        /*! autoprefixer: ignore next */
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 1;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;

        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
        // padding: 16px 0;
        margin-top: 5px;
      }
      .content {
        margin-top: 16px;
        margin-bottom: 21px;
        /*! autoprefixer: ignore next */
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;

        font-size: 12px;
        line-height: 18px;
        color: var(---unnamed-color-707070);
      }
      .share-item__bottom {
        display: flex;
        justify-content: space-between;

        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
        p {
          font-size: 16px;
          line-height: 24px;
          color: var(--unnamed-color-111111);
        }
      }
    }
  }
  .pagination-comp {
    margin-bottom: 45px;
  }

  .s-g-title {
    padding-bottom: 32px;
    text-align: center;
    font-size: 32px;
    line-height: 50px;
    font-weight: 500;
    color: var(--unnamed-color-111111);
  }
  @media (max-width: 992px) {
    padding: 0 40px;
    .breadcrumbs {
      display: none;
    }
    .s-g-title {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .share-list,.top-guide {
      .item-block {
        display: flex;
        flex-direction: column;
        margin-right: 0;
        .img-block {
          border: 1px solid black;
          margin-bottom: 8px;
          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }
        .detail-block {
          margin-left: 0;
          .date {
            font-size: 1rem;
            color: black;
            font-weight: 400;
            transform: scale(.8);
            transform-origin: 0% 0%;
            margin-bottom: 10px;
          }
          .title {
            font-size: 1.3rem;
            line-height: 1.6rem;
            margin: 0;
            margin-bottom: 5px;
            color: black;
          }
          .content {
            margin: 0;
            margin-bottom: 10px;
            color: #707070;
          }
          .btn-outline-white {
            position: relative;
            width: 146px;
            padding: 10px 0;
            font-size: 1rem;
            line-height: 1rem;
            height: auto;
            margin: auto;
          }
        }
      }
    }
  }
}
</style>
